import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'
import { Spacer } from '@telus-uds/components-web'

import PepOffersSection, { PepOffersSectionProps } from './pepOffersSection'

import type { ChainModifiers, Entry, EntrySkeletonType, LocaleCode } from 'contentful'

type AnyEntry = Entry<EntrySkeletonType, ChainModifiers, LocaleCode>

interface PepOffersSectionContentfulFields {
  entryTitle?: string
  headerLabel?: string
  deviceOffers?: AnyEntry[]
}

const ContentfulPepOffersSection = withContentful<PepOffersSectionContentfulFields, PepOffersSectionProps>(
  PepOffersSection,
  {
    headerLabel: (props) => props.fields.headerLabel,
    deviceOffers: (props) => {
      const offers = props.fields.deviceOffers
      if (!offers?.length) return null
      return (
        <>
          {offers.map((offer, index) => (
            <div key={offer?.sys?.id ?? index}>
              <BlockRenderer block={offer} />
              {index < offers.length - 1 && <Spacer space={2} />}
            </div>
          ))}
        </>
      )
    },
  }
)

export default ContentfulPepOffersSection
